export const DEVELOPMENTLINK ="http://localhost:4000/"
export const DEVELOPMENTLINKWSS ="http://localhost:4000/"
export const PRODUCTIONLINK ="https://tokyo-server-backend.herokuapp.com/"
export const PRODUCTIONLINKWEBSOCKET ="wss://tokyo-server-backend.herokuapp.com/"